import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_6_3_3,
  Vessel
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../common/utils";
import {Observable, of} from "rxjs";

@Component({
    selector: 'app-visit-exemptions-exemption-6-3-3',
    templateUrl: './exemption_6_3_3.component.html',
    styleUrls: ['./exemption_6_3_3.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_6_3_3Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_6_3_3;

  portVisitUtils = PortvisitUtils;
  dangerousGoods?: DangerInformation;

  vessel: Vessel;

  ANOTHER_VESSEL = 'Another vessel';

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});
  searchReasonse = (term: string): Observable<string[]> => of([
    "There is a permanent technical defect",
    "There are operational limitations of the vessel unloading facility"]
    .filter(value => !term || value.toLowerCase().includes(term.toLowerCase())));

  newReason = (value: string): string => value;

  placeTypes: string[] = ['',
    'Ashore',
    'Internal transhipment',
    this.ANOTHER_VESSEL
  ];

  resetVesselInfo(resetType: boolean) {
    if (resetType) {
      this.exemption.vesselType = '';
    }
    this.exemption.vesselENI = '';
    this.exemption.vesselIMO = '';
    this.exemption.vesselNameENI = '';
    this.exemption.vesselNameIMO = '';
  }
}

